export { default as CanalList } from './Listar'
export { default as CanalSalida } from  './Salida'
export { default as BoletaCanal } from './verBoleta'